import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import BenchlingProfiler from 'performance/BenchlingProfiler';
import {GRID_VIEW_RENDER_STARTED_EVENT} from 'performance/processInventoryEvents';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import BoxTabState from './BoxTabState';
import GridContainer from './GridContainer';
import GridView from './GridView';
import PlateTabState from './PlateTabState';

export default class GridTabView extends BufferTabView<PlateTabState | BoxTabState> {
  override render(): GridTabView {
    renderToDOM(
      <BenchlingProfiler {...GRID_VIEW_RENDER_STARTED_EVENT}>
        <GridContainer gridId={this.model.get('gridId')}>
          {(childProps) => <GridView {...childProps} />}
        </GridContainer>
      </BenchlingProfiler>,
      this.el
    );
    return this;
  }

  override remove(): GridTabView {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}

GridTabView.className = 'buffer-tab buffer-tab--no-padding';
